<template>
  <div>
    <v-tooltip v-if="disabled" bottom>
      <template #activator="{ on, attrs }">
        <span v-bind="attrs" v-on="on">
          <v-btn disabled color="primary">
            <v-icon>add</v-icon>
            新規案件
          </v-btn>
        </span>
      </template>
      <span
        >サービス終了に伴い、{{
          formattedAddDeadlineDate
        }}以降、新規案件作成はできません。</span
      >
    </v-tooltip>
    <v-btn v-else @click="onClick" color="primary">
      <v-icon>add</v-icon>
      新規案件
    </v-btn>
    <IOModalEdit
      v-if="insertionOrder"
      v-model="modalVisible"
      :insertion-order="insertionOrder"
      :advertiser="advertiser"
      :sales-account-list="salesAccountList"
      :loading="loading"
      :add-deadline-date="addDeadlineDate"
      :delivery-limit="deliveryLimit"
      @success="onSuccess"
      @cancel="onCancel"
      can-edit
    />
  </div>
</template>

<script>
import IOModalEdit from '../IOModalEdit'
import { InsertionOrdersModel } from '@/models/InsertionOrders'
import dayjs from 'dayjs'

export default {
  name: 'AddButton',
  components: { IOModalEdit },
  props: {
    advertiser: {
      type: Object,
      required: true,
    },
    loading: {
      type: Object,
      default: () => {},
    },
    salesAccountList: {
      type: Array,
      default: () => [],
    },
    addDeadlineDate: {
      type: [Date, null],
      required: false,
      default: null,
      validator: val => val === null || val instanceof Date,
    },
    deliveryLimit: {
      type: [Date, null],
      required: false,
      default: null,
      validator: val => val === null || val instanceof Date,
    },
  },
  data() {
    return {
      modalVisible: false,
      insertionOrder: null,
    }
  },
  computed: {
    formattedAddDeadlineDate() {
      return dayjs(this.addDeadlineDate)
        .add(1, 'day')
        .toDate()
        .toLocaleDateString('ja-JP', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })
    },
    disabled() {
      if (!this.addDeadlineDate) return true
      const today = dayjs()
      return today.isAfter(dayjs(this.addDeadlineDate))
    },
  },
  methods: {
    onClick() {
      this.insertionOrder = new InsertionOrdersModel({
        advertiserId: this.advertiser.id,
      })
      this.modalVisible = true
    },
    async onSuccess(savedInsertionOrder) {
      this.insertionOrder = null
      this.modalVisible = false
      const result = await this.$confirm('', {
        cancelText: '閉じる',
        okText: 'キャンペーン作成へ',
        body:
          '広告配信をする場合、キャンペーンの作成および予算設定が必要です。',
      })
      if (!result) {
        return
      }
      this.$emit('openCampaignModal', savedInsertionOrder)
    },
    onCancel() {
      this.insertionOrder = null
      this.modalVisible = false
    },
  },
}
</script>
